import{useReducer as r}from"react";var t=function(){return{}};function n(){return r(t,{})[1]}export{n as default};
//# sourceMappingURL=useForceUpdate.js.map
